class FeaturedProducts extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.variants = this.querySelectorAll('.featured__products-variant');
    this.submitButton = this.querySelector('.featured__products-button');
    this.priceContainer = this.querySelector('.featured__products-price');
    this.productForm = this.querySelector('product-form');
    this.variantInput = this.querySelector('product-form .variant-id-custom');
    this.colorBlocks = this.querySelectorAll('.color-block');
    this.colorHeading = this.querySelector('.featured__products-heading.is--color');

    if (!this.variants.length) return;

    this.variants.forEach((variant) => {
      variant.addEventListener('click', () => {
        this.onVariantClick(variant);
      });
    });

    this.colorBlocks.forEach((block) => {
      const colorItems = block.querySelectorAll('.c-color-item');

      colorItems.forEach((colorItem) => {
        colorItem.addEventListener('click', () => {
          this.onColorClick(colorItem, block);
        });
      });
    });

    if (this.submitButton) {
      this.submitButton.addEventListener('click', () => {
        this.onButtonClick();
      });
    }

    const selected = this.querySelector('.featured__products-variant.is--selected') || this.variants[0];

    if (selected) {
      this.onVariantClick(selected);
    }
  }

  getVariantIds(item) {
    return (item.getAttribute('data-variant-id') || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }

  getAvailabilityList(item) {
    return (item.getAttribute('data-available') || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
  }

  isVariantGroupAvailable(item) {
    const availabilityList = this.getAvailabilityList(item);

    if (!availabilityList.length) return false;

    return !availabilityList.includes('false');
  }

  removeExtraInputs() {
    if (!this.productForm) return;

    this.productForm.querySelectorAll('[data-featured-extra-input="true"]').forEach((input) => {
      input.remove();
    });
  }

  syncFormInputs(item) {
    if (!this.productForm || !this.variantInput) return;

    const form = this.productForm.querySelector('form');
    if (!form) return;

    const ids = this.getVariantIds(item);
    if (!ids.length) return;

    this.removeExtraInputs();

    this.variantInput.value = ids[0];
    this.variantInput.setAttribute('value', ids[0]);

    ids.slice(1).forEach((id, index) => {
      const itemIndex = index + 1;

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = `items[${itemIndex}][id]`;
      idInput.value = id;
      idInput.setAttribute('data-featured-extra-input', 'true');

      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = `items[${itemIndex}][quantity]`;
      quantityInput.value = '1';
      quantityInput.setAttribute('data-featured-extra-input', 'true');

      form.appendChild(idInput);
      form.appendChild(quantityInput);
    });
  }

  updateButtonState(item) {
    if (!this.submitButton) return;

    const isAvailable = this.isVariantGroupAvailable(item);
    const outOfStockText = this.submitButton.getAttribute('data-out-of-stock-text');
    const originText = this.submitButton.getAttribute('data-origin-text');

    if (isAvailable) {
      this.submitButton.removeAttribute('disabled');

      if (originText) {
        this.submitButton.textContent = originText;
      }
    } else {
      this.submitButton.setAttribute('disabled', 'disabled');

      if (outOfStockText) {
        this.submitButton.textContent = outOfStockText;
      }
    }
  }

  updatePrice(item) {
    if (!this.priceContainer) return;

    const priceWrap = item.querySelector('.price-wrap');

    if (priceWrap) {
      this.priceContainer.innerHTML = priceWrap.innerHTML;
    }
  }

  hideAllColorBlocks() {
    this.colorBlocks.forEach((block) => {
      block.style.display = 'none';

      block.querySelectorAll('.c-color-item').forEach((item) => {
        item.classList.remove('is--selected');
      });
    });
  }

  updateColorBlocks(variant) {
    this.hideAllColorBlocks();

    if (this.colorHeading) {
      this.colorHeading.style.display = 'none';
    }

    const productHandle = variant.getAttribute('data-product-handle');
    if (!productHandle) return null;

    const activeColorBlock = this.querySelector(`.color-block[data-product-handle="${CSS.escape(productHandle)}"]`);
    if (!activeColorBlock) return null;

    const colorItems = activeColorBlock.querySelectorAll('.c-color-item');
    if (!colorItems.length) return null;

    const firstColorItem = colorItems[0];

    activeColorBlock.style.display = 'flex';

    if (this.colorHeading) {
      this.colorHeading.style.display = '';
    }

    firstColorItem.classList.add('is--selected');

    return firstColorItem;
  }

  onVariantClick(variant) {
    this.variants.forEach((el) => {
      el.classList.remove('is--selected');
    });

    variant.classList.add('is--selected');

    const firstColorItem = this.updateColorBlocks(variant);
    const activeItem = firstColorItem || variant;

    this.updatePrice(activeItem);
    this.syncFormInputs(activeItem);
    this.updateButtonState(activeItem);
  }

  onColorClick(colorItem, colorBlock) {
    colorBlock.querySelectorAll('.c-color-item').forEach((el) => {
      el.classList.remove('is--selected');
    });

    colorItem.classList.add('is--selected');

    this.updatePrice(colorItem);
    this.syncFormInputs(colorItem);
    this.updateButtonState(colorItem);
  }

  getActiveProductItem() {
    const visibleColorBlock = Array.from(this.colorBlocks).find((block) => {
      return window.getComputedStyle(block).display !== 'none';
    });

    if (visibleColorBlock) {
      const selectedColor = visibleColorBlock.querySelector('.c-color-item.is--selected');

      if (selectedColor) {
        return selectedColor;
      }
    }

    return this.querySelector('.featured__products-variant.is--selected');
  }

  onButtonClick() {
    const selected = this.getActiveProductItem();
    if (!selected) return;

    this.syncFormInputs(selected);
    this.updateButtonState(selected);

    const customButton = this.querySelector('product-form button.product__add-to-cart');

    if (customButton && !customButton.hasAttribute('disabled') && !this.submitButton?.hasAttribute('disabled')) {
      customButton.click();

      setTimeout(() => {
        const cartIcon = document.querySelector('#site-nav--desktop .site-cart-handle');
        if (cartIcon) cartIcon.click();
      }, 1500);
    }
  }
}

customElements.define('featured-products', FeaturedProducts);